import FacebookShare from './FacebookShare'

export default FacebookShare
